import { IDealDirectory, IDealDocument } from 'views/DocumentLibrary/types';
import { TimelineItem } from './types';

export const findDocumentInTree = (tree: IDealDirectory | null, docId: number): IDealDocument | null => {
    if (!tree) return null;

    const found = tree.documents?.find((d: IDealDocument) => d.id === docId);
    if (found) return found;

    if (tree.children) {
        for (const child of tree.children) {
            const result = findDocumentInTree(child, docId);
            if (result) return result;
        }
    }

    return null;
};

// The API returns a numeric id; coerce to string to match TimelineItem.id and the ids used in URLs.
export const normalizeTimelineId = (timeline: TimelineItem): TimelineItem => (
    { ...timeline, id: String(timeline.id) }
);
